import React, { useMemo } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import throttle from 'lodash/throttle'
import { format, add } from 'date-fns'

import { getDateByTimezone } from 'utils/utils'

import TitleHeader from 'components/presenters/header/TitleHeader'
import LoadingAnimation from 'components/presenters/common/LoadingAnimation'
import useGetPointHistoryQuery from 'hooks/queries/point/useGetPointHistoryQuery'
import useGetPointStatisticQuery from 'hooks/queries/point/useGetPointStatisticQuery'

import { PointStatistic, PointHistory, PointRecordEmpty } from './components'

export default function PointHistoryLayout() {
  // const currDate = new Date()
  // nextMonth.setMonth(nextMonth.getMonth() + 1)

  // const [thisYearStr, nextMonthStr] = format(nextMonth, 'yyyy-MM', 'Asia/Seoul').split('-')
  const expireDate = useMemo(() => {
    const currDate = new Date()
    const nextMonth = add(currDate.setDate(1), { months: 1 })
    const convertKST = getDateByTimezone('Asia/Seoul', nextMonth, '-')

    return convertKST
  }, [])
  const history = useHistory()

  const { data, fetchNextPage, isLoading, isFetching, hasNextPage } = useGetPointHistoryQuery(
    {
      limit: 30,
    },
    {
      staleTime: 0,
      cacheTime: 0,
    },
  )

  const { data: pointStatisticResult, isLoading: isPointStatLoading } = useGetPointStatisticQuery(
    {
      expireDate,
    },
    {
      enabled: !!expireDate,
      staleTime: 0,
      cacheTime: 0,
    },
  )

  const onScrollEnd = () => {
    if (isFetching || !hasNextPage) {
      return
    }
    fetchNextPage()
  }

  return (
    <PointHistoryPage>
      <TitleHeader title={'포인트 사용 / 내역'} />

      <PointHistoryContent
        onScroll={throttle((e) => {
          const threshold = 200

          /**
           * clientHeight: 해당 엘리먼트의 사용자에게 보여지는 부분의 높이
           * scrollHeight: 해당 엘리먼트의 전체 높이 (보여지지 않는 부분까지 합쳐짐)
           * scrollTop: 스크롤을 내린 정도
           */
          if (e.target.scrollTop + e.target.clientHeight + threshold >= e.target.scrollHeight) {
            onScrollEnd()
          }
        }, 300)}
      >
        <PointInfo>
          <PointStatistic
            ownedPoint={
              isPointStatLoading
                ? undefined
                : pointStatisticResult.data.point_statistic.exp_point || 0
            }
            toBeExpiredPoint={
              isPointStatLoading
                ? undefined
                : pointStatisticResult.data.point_statistic.expire_point || 0
            }
          />

          <PointUseButton onClick={() => history.push('/mypage/point')}>
            포인트 사용하기
          </PointUseButton>
        </PointInfo>

        <Divider />

        {isLoading ? (
          <LoadingContainer>
            <LoadingWrapper>
              <LoadingAnimation />
            </LoadingWrapper>
          </LoadingContainer>
        ) : data.pages[0].data.points.length <= 0 ? (
          <PointRecordEmpty />
        ) : (
          <PointHistory
            pointRecords={data.pages.reduce((prev, page) => [...prev, ...page.data.points], [])}
          />
        )}
      </PointHistoryContent>
    </PointHistoryPage>
  )
}

const PointHistoryPage = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
`

const PointHistoryContent = styled.div`
  margin-top: calc(100vw * (51 / 375));
  height: calc(100vh - calc(100vw * (51 / 375)));
  overflow-y: scroll;
`

const PointInfo = styled.div`
  padding: 0 calc(100vw * (17 / 375));
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

const PointUseButton = styled.button`
  margin-bottom: calc(100vw * (23 / 375));
  background-color: #ffcf19;
  border-radius: calc(100vw * (11 / 375));
  padding: calc(100vw * (15 / 375)) 0;
  font-weight: 700;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #5a4a0b;
`

const Divider = styled.div`
  height: calc(100vw * (10 / 375));
  background-color: #f7f7f7;
`

const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const LoadingWrapper = styled.div`
  width: calc(100vw * (40 / 375));
  height: calc(100vw * (40 / 375));
  margin-top: calc(100vw * (23 / 375));
`
